import { render, staticRenderFns } from "./FormProtocol.vue?vue&type=template&id=45b693ac"
import script from "./FormProtocol.vue?vue&type=script&lang=js"
export * from "./FormProtocol.vue?vue&type=script&lang=js"
import style0 from "./FormProtocol.vue?vue&type=style&index=0&id=45b693ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports